import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const dropdownRef = useRef(null);
  const dropletsRef = useRef(null);

  const toggleServices = () => setServicesOpen((v) => !v);

  // Close dropdown when clicking outside or pressing ESC
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setServicesOpen(false);
      }
    };
    const handleEsc = (e) => {
      if (e.key === "Escape") setServicesOpen(false);
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  // Create water droplets animation
  useEffect(() => {
    if (!dropletsRef.current) return;

    const dropletsContainer = dropletsRef.current;
    const dropletCount = 15;

    const createDroplet = () => {
      const droplet = document.createElement("div");
      droplet.classList.add("droplet");

      const size = Math.random() * 4 + 4;
      droplet.style.width = `${size}px`;
      droplet.style.height = `${size}px`;

      const position = Math.random() * 100;
      droplet.style.left = `${position}%`;

      const duration = Math.random() * 3 + 3;
      droplet.style.animationDuration = `${duration}s`;

      const delay = Math.random() * 5;
      droplet.style.animationDelay = `${delay}s`;

      dropletsContainer.appendChild(droplet);

      setTimeout(() => {
        droplet.remove();
        createDroplet();
      }, (duration + delay) * 1000);
    };

    for (let i = 0; i < dropletCount; i++) {
      createDroplet();
    }

    return () => {
      while (dropletsContainer.firstChild) {
        dropletsContainer.removeChild(dropletsContainer.firstChild);
      }
    };
  }, []);

  const handleNavClick = () => {
    setMenuOpen(false);
    setServicesOpen(false);
  };

  return (
    <header className="header">
      <div className="water-droplets" ref={dropletsRef}></div>
      <div className="container flex items-center justify-between">
        {/* Logo with oval background */}
        <div className="logo flex items-center">
          <Link to="/" onClick={handleNavClick}>
            <div className="p-2 rounded-full bg-white dark:bg-gray-800">
              <img
                src="/title.png"
                alt="Timeless Home Care Logo"
                className="h-10 w-10 object-contain"
              />
            </div>
          </Link>
        </div>

        {/* Navigation */}
        <nav className="navbar">
          <ul className={menuOpen ? "show" : ""}>
            <li>
              <Link to="/" onClick={handleNavClick}>Home</Link>
            </li>
            <li className={`dropdown ${servicesOpen ? "active" : ""}`} ref={dropdownRef}>
              <button
                type="button"
                className="dropdown-toggle"
                aria-haspopup="true"
                aria-expanded={servicesOpen}
                onClick={toggleServices}
              >
                Services <span className="chevron" aria-hidden="true"></span>
              </button>
              <ul className={`dropdown-menu ${servicesOpen ? "show" : ""}`} role="menu">
                <li><Link to="/advanced-nursing-care" onClick={handleNavClick}>Advanced Nursing Care</Link></li>
                <li><Link to="/basic-supportive-care" onClick={handleNavClick}>Basic Supportive Care</Link></li>
                <li><Link to="/dementia-care" onClick={handleNavClick}>Dementia Care</Link></li>
                <li><Link to="/physiotherapy" onClick={handleNavClick}>Physiotherapy</Link></li>
                <li><Link to="/pre-post-op-care" onClick={handleNavClick}>Pre & Post-Operative Care</Link></li>
                <li><Link to="/wound-dressing" onClick={handleNavClick}>Wound Dressing</Link></li>
              </ul>
            </li>
            <li><Link to="/about" onClick={handleNavClick}>About Us</Link></li>
            <li><Link to="/contact" onClick={handleNavClick}>Contact</Link></li>
          </ul>

          {/* Mobile Hamburger */}
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span className="hamburger-icon">&#9776;</span>
          </button>
        </nav>
      </div>
    </header>
  );
}

export default Header;
